import _ from 'lodash';
import { IMessagesState } from './types';
import {
  SHOW_ERROR,
  Actions,
  SHOW_SUCCESS,
  SHOW_PERMANENT_LOGOUT,
  SET_VERSION_FETCH_COMPLETE,
  SHOW_TOAST_MESSAGE,
  HIDE_TOAST_MESSAGE,
  HIDE_PERMANENT_LOGOUT,
} from './actions';

const initialState: IMessagesState = {
  toastMessage: {
    status: null,
    text: null,
  },
  message: null,
  show: false,
  showSuccess: false,
  logoutReason: null,
  versionFetchComplete: false,
};

const reducer = (state: IMessagesState = initialState, action: Actions) => {
  switch (action.type) {
    case SHOW_TOAST_MESSAGE:
      return {
        ...state,
        toastMessage: action.payload.toastMessage,
      };

    case HIDE_TOAST_MESSAGE:
      return {
        ...state,
        toastMessage: {
          status: null,
          text: null,
        },
      };
    case SHOW_ERROR:
      return {
        ...state,
        show: action.payload.show,
        message: action.payload.message,
      };
    case SHOW_SUCCESS:
      return {
        ...state,
        showSuccess: action.payload.show,
        message: action.payload.message,
      };
    case SHOW_PERMANENT_LOGOUT:
      return {
        ...state,
        logoutReason: action.payload,
      };
    case HIDE_PERMANENT_LOGOUT:
      return {
        ...state,
        logoutReason: null,
      };
    case SET_VERSION_FETCH_COMPLETE:
      return {
        ...state,
        versionFetchComplete: true,
      };
    default:
      return state;
  }
};

export default reducer;
